import React, { useState } from 'react';
import { BACKEND_URL } from '../utils/config';

function ContactFormChinese() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

//...
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/others/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert('郵件已成功發送！');
        setFormData({ name: '', email: '', message: '' });
      } else {
        alert('發送郵件失敗。請再試一次。');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('發生錯誤。請稍後再試。');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="App-header" id="contact-form" style={{ position: 'relative', top: '0vh' }}>
      <div className="contact-text">
        <h1 className="hero-title">聯絡我們</h1>
        <p className="hero-subtitle" style={{ width: "80%" }}>
          有問題或想要聯繫我們？請填寫以下表格，我們將儘快回覆您。
        </p>
        <form onSubmit={handleSubmit} className="contact-form-container">
          <input 
            type="text" 
            name="name" 
            placeholder="姓名" 
            required 
            className="contact-form-input"
            value={formData.name}
            onChange={handleChange}
          />
          <input 
            type="email" 
            name="email" 
            placeholder="電子郵件" 
            required 
            className="contact-form-input"
            value={formData.email}
            onChange={handleChange}
          />
          <textarea 
            name="message" 
            placeholder="請在此輸入您的留言" 
            required 
            rows="5" 
            className="contact-form-textarea"
            value={formData.message}
            onChange={handleChange}
          />
          <button 
            type="submit" 
            className="button-arrow" 
            style={{ width: 'fit-content' }}
            disabled={isLoading}
          >
            {isLoading ? '傳送中...' : '傳送郵件'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContactFormChinese;
